import { createContext } from 'react';
export var AddNotificationContext = createContext(function () { });
//# sourceMappingURL=AddNotificationContext.js.map